import React from "react";
import "./Services.css";
import { Outlet } from "react-router-dom";
const Services = () => {
  return (
    <>
        <Outlet />
      {/* <div className="Services">
      </div> */}
    </>
  );
};

export default Services;
